"use client";

import { clsx } from "@trydig/ui";
import { useState } from "react";
import { type UseRefinementListProps, useRefinementList } from "react-instantsearch";
import { Plus } from "~/components/icons/16/Plus";
import { Minus } from "~/components/icons/Minus";
import { textconfig } from "~/textconfig";
import styles from "./DropdownSection.module.css";

const INITIAL_DISPLAY_COUNT = 5;

export const DropdownSection = (props: UseRefinementListProps & { title: string }) => {
	const { items, refine } = useRefinementList(props);
	const [isOpen, setIsOpen] = useState(false);
	const [showAll, setShowAll] = useState(false);

	const toggleOpen = () => {
		setIsOpen(!isOpen);
		if (isOpen) {
			setShowAll(false);
		}
	};

	const visibleItems = showAll ? items : items.slice(0, INITIAL_DISPLAY_COUNT);
	const hasMore = items.length > INITIAL_DISPLAY_COUNT;

	return (
		<div className={styles.root}>
			<button className={styles.header} onClick={toggleOpen}>
				<div className={styles.title}>{props.title}</div>
				<div className={clsx(styles.controller, isOpen && styles.active)}>
					<div className={styles.minus}>
						<Minus />
					</div>
					<div className={styles.plus}>
						<Plus />
					</div>
				</div>
			</button>

			{isOpen && (
				<div>
					{visibleItems.map((item) => (
						<CheckBoxWithCount item={item} refine={refine} key={item.value} />
					))}

					{!showAll && hasMore && (
						<button className={styles.showMoreBtn} onClick={() => setShowAll(true)}>
							Vis mer
						</button>
					)}
				</div>
			)}
		</div>
	);
};

const formatCheckboxLabel = (label: string, labels: Record<string, string>) => {
	const formattedLabel = labels[label];

	if (formattedLabel) {
		return formattedLabel;
	}

	return label;
};

const CheckBoxWithCount = ({
	item,
	refine,
}: {
	item: {
		label: string;
		value: string;
		isRefined: boolean;
		count: number;
	};
	refine: (value: string) => void;
}) => {
	return (
		<div className={styles.checkbox}>
			<label className={styles.label} htmlFor={item.value}>
				<div className={styles.group}>
					<input
						value={item.value}
						checked={item.isRefined}
						onChange={() => refine(item.value)}
						type="checkbox"
						id={item.value}
						className={clsx(styles.input)}
						disabled={item.count === 0}
					/>
					{formatCheckboxLabel(item.label, textconfig.plp.filtersLabels)}
				</div>
				<span className={styles.filterNumber}>{item.count}</span>
			</label>
		</div>
	);
};
